import { render, staticRenderFns } from "./supplierDeposit.vue?vue&type=template&id=9f2ddbba&scoped=true"
import script from "./supplierDeposit.vue?vue&type=script&lang=js"
export * from "./supplierDeposit.vue?vue&type=script&lang=js"
import style0 from "./supplierDeposit.vue?vue&type=style&index=0&id=9f2ddbba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2ddbba",
  null
  
)

export default component.exports